import { type YakurekiDetail } from '@/shared/types/yakurekiCore'
import {
  type SoapContent,
  type SoapContentItem,
  type SoapSectionKeys,
} from '@/shared/types/yakurekiSoap'

import {
  SOAP_TYPE_TO_SECTION,
  type SoapMasterType,
  type SoapSet,
} from '../types/masters'

// 挿入する 1 行 (どの section に何を入れるか)。
export interface MasterInsertLine {
  section: SoapSectionKeys
  content: string
}

// 定型文 → 挿入行。移行元の並び順 (配列順) をそのまま使う。
//
// 区分の無い行 (= 旧 文章マスタからの移行分) はここでは入れ先が決まらないので落とす。
// その行はダイアログ側で 6 区分ボタンを開いて薬剤師に選ばせる。
export const linesFromSoapSet = (soapSet: SoapSet): MasterInsertLine[] =>
  soapSet.lines
    .filter((line) => line.soap_type !== null && line.content.trim() !== '')
    .map((line) => ({
      section: SOAP_TYPE_TO_SECTION[line.soap_type as SoapMasterType],
      content: line.content,
    }))
    // 未知の SOAP 区分が来たら黙って捨てる (= 取込側で弾いているが二重で守る)。
    .filter((line) => line.section !== undefined)

/**
 * 現在の SOAP blob の末尾に定型文を追記した blob を返す (pure)。
 *
 * - 各 section の**末尾**に足す。既存行の順序・採否は触らない
 * - 挿入行は `is_selected: true` (= 採用行。コピー / AnyCOMPASS 転記にそのまま乗る)
 * - 空行は呼び出し前に落としてある想定だが、ここでも念のため捨てる
 *
 * 返り値は `useUpdateSoapMutation` にそのまま渡せる形
 * (= `soaps` から id を落とした残り。useSoapLineEditing.commit と同じ作法)。
 */
export const appendMasterLines = (
  soaps: YakurekiDetail['soaps'],
  lines: MasterInsertLine[]
): SoapContent | null => {
  if (!soaps) return null
  const { id: _id, ...rest } = soaps
  const updated = { ...rest } as SoapContent

  lines.forEach(({ section, content }) => {
    if (content.trim() === '') return
    const current = (updated[section] ?? []) as SoapContentItem[]
    updated[section] = [...current, { content, is_selected: true }]
  })

  return updated
}
